/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectionreconnecting1Inputs */



/**
* | output |
* | --- |
* | "Reconnecting..." |
*
* @param {Connectionreconnecting1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const connectionreconnecting1 = /** @type {((inputs?: Connectionreconnecting1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectionreconnecting1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reconnecting...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reconectando...")
	return /** @type {LocalizedString} */ ("Переподключение...")
});
export { connectionreconnecting1 as "connectionReconnecting" }